import wrapperHOC from "@Utils/wrapperHOC";
import useTranslationHook from "hooks/useTranslationHook";
import formatClassNames from "@Utils/clientUtils/stringUtility/formatClassNames";
import InfoIcon from "@Icons/InfoIcon";
import { CommunityData } from "../types";
import { resolveCopy, renderBoldText } from "../utils";
import HeroCard from "./HeroCard";
import styles from "../neighbourhoodSection.module.scss";

type CommunityTabProps = {
  data: CommunityData;
};

const KEY_PREFIX = "propertypage.components.neighbourhood.community";

const CommunityTab = ({ data }: CommunityTabProps) => {
  const { t } = useTranslationHook();
  const statLabel = data.statLabelKey ? resolveCopy(t, data.statLabelKey) : undefined;
  const source = resolveCopy(t, data.sourceKey);
  const noiseStatement = data.noiseLevel
    ? resolveCopy(t, `${KEY_PREFIX}.banner.noise.${data.noiseLevel}`)
    : undefined;

  return (
    <div className={styles.contentArea}>
      <HeroCard
        image={data.heroImage}
        stat={data.mainStat}
        label={statLabel}
        alt="Community neighbourhood view"
      />
      <div className={styles.detailsSection}>
        <div>
          {(() => {
            let renderedCount = 0;
            return data.facts.map((fact, index) => {
              const statement = resolveCopy(t, fact.key, fact.params);
              if (!statement) return null;
              const isFirst = renderedCount === 0;
              renderedCount += 1;

              return (
                <div key={fact.key}>
                  <div
                    className={formatClassNames(styles.tableRow, isFirst && styles.tableRowFirst)}
                  >
                    <span className={styles.tableText}>{renderBoldText(statement)}</span>
                  </div>
                  {index < data.facts.length - 1 && <div className={styles.tableDivider} />}
                </div>
              );
            });
          })()}

          {noiseStatement && (
            <div className={styles.noiseBanner}>
              <span className={styles.noiseBannerText}>{renderBoldText(noiseStatement)}</span>
            </div>
          )}
        </div>
        <p className={styles.sourceText}>
          <span className={styles.sourceIcon} aria-hidden="true">
            <InfoIcon width="14" height="14" fill="#6b7280" />
          </span>
          {source}
        </p>
      </div>
    </div>
  );
};

export default wrapperHOC(CommunityTab, {
  componentName: "CommunityTab",
  showForChina: false,
  showForWhiteLable: false,
});
